import { useTranslation } from "react-i18next";
import { HelmetHead } from "../HelmetHead";

const HelmetHeadLeagues = () => {
  const { t } = useTranslation("leaguesAndCups");
  return (
    <HelmetHead
      title={t(
        "leagues.metadata.title",
        "Create & Join Fantasy Football Leagues | Fantasy Premier League",
      )}
      description={t(
        "leagues.metadata.description",
        "To view all types of leagues including head-to-head, classic & global, as well as creating & joining new leagues, visit the official website of the Premier League.",
      )}
    />
  );
};

export default HelmetHeadLeagues;
